// extracted by mini-css-extract-plugin
export default {"icon":"ygyXr7","rounded-icon":"I7KdGm","roundedIcon":"I7KdGm"};